import {Button, Modal} from "antd";
import parse from "html-react-parser";
import React from "react";
import {Constants} from "../../../core/helpers/constants";
import {ErrorDto} from "../../../core/models/dtos/error.dto";
import FirebaseService from "../../../core/services/firebase.service";
import "./ApiErrorModal.scss";

interface IProps {
  apiError?: ErrorDto;
  callbackRetry: () => void;
  callbackGoToBip: () => void;
}

const ApiErrorModal = (props: IProps) => {

  const errorGenericTitle = FirebaseService.getValue(FirebaseService.wheel_error_title);
  const errorGenericDescription = FirebaseService.getValue(FirebaseService.wheel_error_description);
  const errorLinkTitle = FirebaseService.getValue(FirebaseService.wheel_link_exp_title);
  const errorLinkDescription = FirebaseService.getValue(FirebaseService.wheel_link_exp_description);

  const isLinkError = (): boolean => {
    return props.apiError?.code === Constants.errorCodeTicketAlreadyUsed;
  }

  const getTitle = (): string => {
    if (props.apiError) {
      return isLinkError()
        ? errorLinkTitle
        : errorGenericTitle;
    }
    return '';
  }

  const getDescription = (): string => {
    if (props.apiError) {
      return isLinkError()
        ? errorLinkDescription
        : errorGenericDescription;
    }
    return '';
  }

  return (
    <Modal
      className="api-error-modal"
      maskStyle={{backdropFilter: "blur(4px)"}}
      visible={!!props.apiError}
      centered
      closable={false}
      footer={false}
    >
      <div className="body">
        <div className="content">
          <p className="title">
            {parse(getTitle())}
          </p>
          <p className="description">
            {parse(getDescription())}
          </p>

          <div className="button-wrapper">

            {
              isLinkError() &&
              <Button
                className="button button-blue"
                onClick={props.callbackGoToBip}
              >
                {parse(FirebaseService.getValue(FirebaseService.wheel_link_exp_button))}
              </Button>
            }

            {
              !isLinkError() &&
              <React.Fragment>
                <Button
                  className="button button-blue"
                  onClick={props.callbackRetry}
                >
                  {parse(FirebaseService.getValue(FirebaseService.wheel_error_try_again))}
                </Button>
                <Button
                  className="button button-white"
                  onClick={props.callbackGoToBip}
                >
                  {parse(FirebaseService.getValue(FirebaseService.wheel_error_go_back))}
                </Button>
              </React.Fragment>
            }
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default ApiErrorModal;
